export default __webpack_public_path__ + "static/media/b30.d2f79afe.png";